"use strict";

var _toConsumableArray = require("/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _defineProperty = require("/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/defineProperty.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TPWearable = void 0;

var validation_1 = require("../../validation");

var merkle_tree_1 = require("../merkle-tree");

var base_wearable_1 = require("./base-wearable");
/** @alpha */


var TPWearable;

(function (TPWearable) {
  TPWearable.schema = _objectSpread(_objectSpread({}, base_wearable_1.BaseWearable.schema), {}, {
    properties: _objectSpread(_objectSpread({}, base_wearable_1.BaseWearable.schema.properties), {}, {
      content: {
        type: 'object',
        additionalProperties: {
          type: 'string'
        },
        required: []
      },
      merkleProof: merkle_tree_1.MerkleProof.schema
    }),
    required: [].concat(_toConsumableArray(base_wearable_1.BaseWearable.schema.required), ['content'])
  });
  var schemaValidator = (0, validation_1.generateValidator)(TPWearable.schema);

  TPWearable.validate = function (wearable) {
    return schemaValidator(wearable) && base_wearable_1.BaseWearable.validateDuplicatedLocales(wearable.descriptions) && base_wearable_1.BaseWearable.validateDuplicatedLocales(wearable.names);
  };
})(TPWearable = exports.TPWearable || (exports.TPWearable = {}));